export default "__VITE_ASSET__76f62749__"